// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"06e8cf58","249":"06e8cf58"}[chunkId] + ".chunk.css";
};